import React, {useState} from 'react';
import dayjs from "dayjs";
import {useAppraisalsContext} from "../../contexts/AppraisalsContext";
import DataTable from "../DataTable";
import FilterSelect from "../../../../common/components/FilterSelect";
import FieldCheckbox from "../../../../common/components/FieldCheckbox";
import FilterInput from "../../../../common/components/FilterInput";
import FilterDate from "../../../../common/components/FiltersDateFromTo";
import {columns} from "../../constants/columns";
import styles from './styles.module.scss';

const AppraisalsTable = () => {
    const [showMore, setShowMore] = useState(false);
    const {
      data,
      page,
      setPage,
      search: {
        freeText,
        type,
        role,
        decidingAppraiser,
        version,
        block,
        parcel,
        localCommittee,
        issueInDispute,
        publicationDateFrom,
        publicationDateTo,
        decisionDateFrom,
        decisionDateTo,
        city,
        street,
        neighborhood,
        propertyType,
        use,
        designation,
        area,
        unitCount,
        floor,
        propertyCondition,
        constructionType,
        effectiveDateFrom,
        effectiveDateTo,
        publicationDate,
        purpose,
        plan,
        cities,
        streets
      }
    } = useAppraisalsContext();

    return (
      <div className={styles.listContainer}>
        <h1 className={styles.pageTitle}>שומות מכריעות</h1>
        <div className={styles.mainFiltersContainer}>
          <FilterInput
            placeholder="טקסט חופשי במסמך"
            value={freeText.value}
            onChange={event => freeText.onChange(event.target.value)}
          />
          <FilterSelect
            placeholder="סוג שומה"
            filter={type}
            options={[]}
          />
          <FilterSelect
            placeholder="תפקיד שמאי"
            filter={role}
            options={[]}
          />
          <FilterSelect
            placeholder="שמאי מכריע"
            filter={decidingAppraiser}
            options={[]}
          />
          <FilterSelect
            placeholder="גרסת שומה"
            filter={version}
            options={[]}
          />
          <FilterInput
            placeholder="גוש"
            value={block.value}
            onChange={event => block.onChange(event.target.value)}
          />
          <FilterInput
            placeholder="חלקה"
            value={parcel.value}
            onChange={event => parcel.onChange(event.target.value)}
          />
          <FilterSelect
            placeholder="ועדה מקומית"
            filter={localCommittee}
            options={[]}
          />
          <FilterSelect
            placeholder="סוגיה במחלוקת"
            filter={issueInDispute}
            options={[]}
          />
          <FilterDate
            placeholder={'מ-תאריך פרסום'}
            filter={publicationDateFrom}
            maxDate={dayjs(publicationDateTo.value) || dayjs().add(10, 'year')}
          />
          <FilterDate
            placeholder={'עד-תאריך פרסום'}
            filter={publicationDateTo}
            maxDate={dayjs().add(10, 'year')}
            minDate={dayjs(publicationDateFrom.value)}
          />
          <FilterDate
            placeholder={'מ-תאריך הכרעה'}
            filter={decisionDateFrom}
            maxDate={dayjs(decisionDateTo.value) || dayjs().add(10, 'year')}
          />
          <FilterDate
            placeholder={'עד-תאריך הכרעה'}
            filter={decisionDateTo}
            maxDate={dayjs().add(10, 'year')}
            minDate={dayjs(decisionDateFrom.value)}
          />
        </div>
        <FieldCheckbox
          fieldId={'showAdvanced'}
          variant={'slider'}
          label={'סינון מתקדם'}
          onChange={() => setShowMore(!showMore)}
          containerStyles={styles.sliderMargins}
        />
        {showMore &&
          <div className={styles.secondaryFiltersContainer}>
            <FilterSelect
              placeholder="עיר"
              filter={city}
              options={cities}
            />
            <FilterSelect
              placeholder="רחוב"
              filter={street}
              options={streets}
              disabled={!city?.value}
            />
            <FilterInput
              placeholder="שכונה"
              value={neighborhood.value}
              onChange={event => neighborhood.onChange(event.target.value)}
            />
            <FilterSelect
              placeholder="סוג נכס"
              filter={propertyType}
              options={[]}
            />
            <FilterInput
              placeholder="שימוש"
              value={use.value}
              onChange={event => use.onChange(event.target.value)}
            />
            <FilterInput
              placeholder="ייעוד"
              value={designation.value}
              onChange={event => designation.onChange(event.target.value)}
            />
            <FilterInput
              placeholder="שטח"
              value={area.value}
              onChange={event => area.onChange(event.target.value)}
            />
            <FilterInput
              placeholder={`מספר יח"ד`}
              value={unitCount.value}
              onChange={event => unitCount.onChange(event.target.value)}
            />
            <FilterInput
              placeholder={`קומה`}
              value={floor.value}
              onChange={event => floor.onChange(event.target.value)}
            />
            <FilterInput
              placeholder={`מצב הנכס`}
              value={propertyCondition.value}
              onChange={event => propertyCondition.onChange(event.target.value)}
            />
            <FilterInput
              placeholder={`סוג הבנייה`}
              value={constructionType.value}
              onChange={event => constructionType.onChange(event.target.value)}
            />
            <FilterDate
              placeholder={'מ-מועד קובע'}
              filter={effectiveDateFrom}
              maxDate={dayjs(publicationDateTo.value) || dayjs().add(10, 'year')}
            />
            <FilterDate
              placeholder={'עד-מועד קובע'}
              filter={effectiveDateTo}
              maxDate={dayjs().add(10, 'year')}
              minDate={dayjs(effectiveDateFrom.value)}
            />
            <FilterDate
              placeholder={'תאריך פרסום'}
              filter={publicationDate}
            />
            <FilterInput
              placeholder={`מטרת השומה`}
              value={purpose.value}
              onChange={event => purpose.onChange(event.target.value)}
            />
            <FilterInput
              placeholder={`תוכנית`}
              value={plan.value}
              onChange={event => plan.onChange(event.target.value)}
            />
          </div>
        }
        <DataTable
          data={data?.list ?? []}
          columnsList={columns}
          totalPages={data?.totalPageCount ?? 0}
          totalResultCount={data?.totalResultCount ?? 0}
          page={page}
          setPage={setPage}
        />
      </div>
    );
  }
;

export default AppraisalsTable;